import React from 'react';

import { ServiceSortBarProps } from './ServiceSortBar.props';
import { SortContainer, SortLabel, SortPill } from './ServiceSortBar.styles';
import { SortOption } from '../../MobileServices.utils';

const SORT_OPTIONS: Array<{ value: SortOption; label: string }> = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'sla', label: 'SLA' },
  { value: 'mostUrgent', label: 'Most Urgent' },
  { value: 'zone', label: 'Zone' },
];

export const ServiceSortBar: React.FC<ServiceSortBarProps> = ({ activeSort, onSortChange }) => (
  <SortContainer role="radiogroup" aria-label="Sort services by">
    <SortLabel>Sort:</SortLabel>
    {SORT_OPTIONS.map((option) => (
      <SortPill
        key={option.value}
        active={activeSort === option.value}
        onClick={() => onSortChange(option.value)}
        role="radio"
        aria-checked={activeSort === option.value}
        aria-label={`Sort by ${option.label}`}
      >
        {option.label}
      </SortPill>
    ))}
  </SortContainer>
);
